export const TEXT_DURATION = 0.7;
export const COIN_DURATION = 0.1;
export const COIN_DELAY = 0.1;

export const TEXT_OFFSET = 300;
export const EASE = 'Linear.easeInOut';
